class CustomNav {
	constructor(config) {
		this.config = Object.assign({
			flickity: null,
			scope: null,
			dot: '[data-flickity-nav="dot"]',
			prev: '[data-flickity-nav="prev"]',
			next: '[data-flickity-nav="next"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.updateDotsAndButtons(this.config.flickity.selectedIndex);
		this.addEventListeners();
	}

	updateDotsAndButtons(index) {
		this.$scope.find(`${this.config.prev}, ${this.config.next}`).removeClass('disabled');
		this.$scope.find(this.config.dot).removeClass('active');
		if(index <= 0) {
			this.$scope.find(this.config.prev).addClass('disabled');
		}
		if(index >= this.config.flickity.slides.length - 1) {
			this.$scope.find(this.config.next).addClass('disabled');
		}
		this.$scope.find(`${this.config.dot}[data-index="${index}"]`).addClass('active');
	}

	addEventListeners() {
		this.$scope.on('click', this.config.next, this.next.bind(this));
		this.$scope.on('click', this.config.prev, this.prev.bind(this));
		this.$scope.on('click', this.config.dot, this.setSlideIndexByDot.bind(this));
		this.config.flickity.on('change', this.updateDotsAndButtons.bind(this));
	}

	next(event) {
		event.preventDefault();
		this.config.flickity.next();
	}

	prev(event) {
		event.preventDefault();
		this.config.flickity.previous();
	}

	setSlideIndexByDot(event) {
		event.preventDefault();
		this.setSlideIndex($(event.currentTarget).data('index'));
	}

	setSlideIndex(index) {
		this.config.flickity.select(index);
	}
}

export default CustomNav;